import React from 'react';
import {get} from '../Storage';
import axios from 'axios';
import {Message, MGSiteButton} from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetMemobetLoaderComponent';

var styles = AppSettings.styles;

class MemobetLoader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            
            error: false,
            errorMessage: "",
            showLoading: false
        }
        
        //this.openPopupMemobet = this.openPopupMemobet.bind(this);
        //this.closeHandle = this.closeHandle.bind(this);
        this.memobetLoadingHandle = this.memobetLoadingHandle.bind(this);
    }

    /*   openPopupMemobet(event){
        this.setState({
            opened: true
        });
    }

    closeHandle(event){
        this.setState({
            opened: false
        });
    }
    */
   
    memobetLoadingHandle(event){
        var code = this.refs.cartCode.value.trim();
        if(this.state.showLoading){
            return;
        }        

        if(code == ""){
            this.setState({
                showLoading: false,
                error: true,
                errorMessage: "Inserisci un codice valido"
            });
            return;   
        }
        this.setState({
            showLoading: true,
            error: false,
            errorMessage: ""
        });

        var url = AppSettings['env'].urlUserBoxGetMemobet.replace('[CODE]', code);
        axios.get(url)
            .then(({data, status, statusText}) => {
                var error = false;
                var errorMessage = "";
                var showLoading = false;
                if(data.length == 0){
                    error = true;
                    errorMessage = "MemoBet non trovata";
                }
                else{
                    if(data[0].cart == null){
                        error = true;
                        errorMessage = data[0].errors[0].userMessage;
                    }
                    // Ok
                    else{
                       showLoading = true;
                       location.href = "/scommesse-sportive?cart="+code;
                    }
                }
                this.setState({
                    error: error,
                    errorMessage: errorMessage,
                    showLoading: false
                });
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "Si è verificato un errore durante il caricamento della Memobet.",
                    data: [],
                    showLoading: false
                });
            });
    }

    render(){
        var errorComponent = "";
        if(this.state.error){
            errorComponent = <Message type="error">{this.state.errorMessage}</Message>
        }
        return(
            <div className="mg-memobet-loader">
                
                <div className="mg-input-text">      
                    <input className="mg-input-text" type="text" ref="cartCode" defaultValue="" required/>
                    <span className="bar">
                        <i className="left" style={styles.primaryBackgroundColor}/><i className="right" style={styles.primaryBackgroundColor}/>
                    </span>
                    <label>Se hai salvato una giocata inserisci qui il tuo <strong>codice Memobet</strong></label> 
                </div>                                 
              
                <MGSiteButton
                    title="Carica"
                    class=""
                    label="Carica"
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={true}
                    actionFunc={this.memobetLoadingHandle}
                />

                {errorComponent}  
            </div>
        );
    }

  /*  render() {
        if(!this.state.opened){
            return  <RaisedButton label={"Carica MemoBet"}
                         onClick={this.openPopupMemobet}
                         primary={false}
                         style={styles.fullWidth}
                         labelStyle={styles.labelCTA}
                         
                         />;
        }

        return (
            <UPopup title="Carica una Memobet" opened={this.state.opened} onCloseAction={this.closeHandle}>
                    {this.state.showLoading?
                        <CircularProgress style={styles.loadingIcon}/>
                        : this.renderForm()
                    }
            </UPopup>
        );
  }    */  
}

MemobetLoader.displayName = componentName;

// PropTypes validation
MemobetLoader.propTypes = {
    
};

// default props
MemobetLoader.defaultProps = {
   
};

export default MemobetLoader;